export const SMARTYSTREETS_DPV_MATCH_CODES = {
  CONFIRMED: 'Y',
  NOT_CONFIRMED: 'N',
  CONFIRMED_DROPPING_SECONDARY: 'S',
  CONFIRMED_MISSING_SECONDARY: 'D',
};
